const styles = {
	banner: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		backgroundPosition: 'center right',
		minHeight: [250, 294],
		padding: [20, 30, 60],
		borderRadius: 6,
		position: 'relative',
		overflow: 'hidden',
		boxShadow: '0 2px 4px rgba(0, 0, 0, 0.06)',
		'::after': {
			content: '""',
			display: 'block',
			width: '100%',
			height: '100%',
			background: [
				'linear-gradient(to right, rgba(0, 0, 0, 0.75) , rgba(0, 0, 0, 0))',
				'linear-gradient(to right, rgba(0, 0, 0, 0.48) , rgba(0, 0, 0, 0))',
			],
			position: 'absolute',
			top: 0,
			left: 0,
			zIndex: 0,
		},
	},
	bannerContent: {
		color: 'white',
		position: 'relative',
		zIndex: 1,
		h2: {
			fontSize: [3, 4],
			fontWeight: 400,
			marginBottom: 30,
			strong: {
				fontWeight: 700,
			},
		},
		button: {
			minWidth: 146,
			marginTop: 30,
			svg: {
				marginLeft: 0,
				marginRight: 10,
			},
		},
	},
};

export default styles;
